import CurrencyFilter from "./currency.filter";
import DateFilter from "./date.filter";
import imageSourceFilter from "./image-source.filter";

export default {
  ...DateFilter,
  ...CurrencyFilter,
  ...imageSourceFilter,
};
